export default {
  judicialLawsuitQuery: state => state.query,
  judicialLawsuits: state => state.lawsuits,
  judicialLawsuitsPagination: state => state.pagination,
  judicialLawsuitDetail: state => state.detail,
  isLoadingJudicialLawsuitDetail: state => state.isLoadingDetail,
  isLoadingJudicialLawsuitQuery: state => state.isLoadingQuery,
  isLoadingJudicialLawsuits: state => state.isLoadingLawsuits,
  isCreatingJudicialLawsuitQuery: state => state.isCreatingQuery,
  judicialLawsuitError: state => state.error
}



// WEBPACK FOOTER //
// ./src/store/modules/judicial_lawsuits/getters.js